import {
	CheckCircleFilled,
	LineChartOutlined,
	LockOutlined,
	SafetyCertificateFilled
} from "@ant-design/icons";
import { Button, Input, notification, Radio } from "antd";
import React from "react";
import { connect } from "react-redux";
import { addNewsLetters } from "../../redux/actions/API/newsLetters";
import { IDataResponse } from "../../redux/types/API/ApiResponse";
import costsaving from "../../Utility/images/costsaving.webp";
import fast_implement from "../../Utility/images/fastimplementation.webp";
import peopleCreating from "../../Utility/images/peopleCreating.avif";
import place_holder from "../../Utility/images/place_holder.avif";
import pngTree from "../../Utility/images/pngtree.avif";
import tally from "../../Utility/images/tally.webp";
import ChooseEaseMain from "./ChooseEaseMain";
import "./Features.css";
import KeyClients from "./LandingPageComponents/Main/KeyClients";
// import ChooseEaseMain from "./ChooseEaseMain";
// import ChooseEase from "./LandingPageComponents/Main/ChooseEase/ChooseEase";
// import ChooseEasePortal from "./ChooseEasePortal";
// import ChooseEase from "./LandingPageComponents/Main/ChooseEase/ChooseEase";

interface IFeaturesProps {
	addNewsLetters: Function;
	addNewsLettersState: IDataResponse;
}

interface IFeaturesState {
	isMobile: boolean;
	planSize: string;
	activeBlock: string;
	email: string;
	loading: boolean;
}
type NotificationType = "success" | "info" | "warning" | "error";
class Features extends React.Component<IFeaturesProps, IFeaturesState> {
	constructor(props: IFeaturesProps) {
		super(props);
	}
	heroRef = React.createRef<HTMLDivElement>();
	state = {
		isMobile: false,
		planSize: "yearly",
		activeBlock: "silver",
		email: "",
		loading: false,
	};
	openNotificationWithIcon = (type: NotificationType, message: string) => {
		notification.open({
			message: message,
			type: type,
			duration: 3,
		});
	};
	private scrollAnimationFrame: number | null = null;

	componentDidMount() {
		this.updateIsMobile();
		window.addEventListener("resize", this.updateIsMobile);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateIsMobile);
		if (this.scrollAnimationFrame) {
			cancelAnimationFrame(this.scrollAnimationFrame);
		}
	}

	componentDidUpdate(
		prevProps: Readonly<IFeaturesProps>,
		prevState: Readonly<IFeaturesState>,
		snapshot?: any
	): void {
		if (
			prevProps.addNewsLettersState?.loading &&
			!this.props.addNewsLettersState?.loading
		) {
			if (this.props.addNewsLettersState?.error) {
				this.openNotificationWithIcon(
					"error",
					this.props.addNewsLettersState?.error?.message
				);
				this.setState({ loading: false });
			} else {
				this.setState({ loading: false, email: "" });
				this.openNotificationWithIcon("success", "Thank you for subscribing!");
			}
		}
	}

	handleNewsletterSubscribe = () => {
		const { email } = this.state;
		const { addNewsLetters } = this.props;

		if (!email) {
			this.openNotificationWithIcon(
				"error",
				"Please enter your email address."
			);
			return;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			this.openNotificationWithIcon(
				"error",
				"Please enter a valid email address."
			);
			return;
		}
		this.setState({ loading: true });
		const payload = {
			email,
			pageId: "home",
			ip_address: null,
			status: 1,
		};

		addNewsLetters(payload);
	};

	updateIsMobile = () => {
		this.setState({ isMobile: window.innerWidth <= 767 });
	};

	render() {
		const { isMobile } = this.state;
		return (
			<>
				<KeyClients />
				<ChooseEaseMain />

				<div className="grid-background">
					<div className="homeContentBody container">
						<span className="heroBadge ">Security and Reliability</span>
						<div className="heroTitleBody">
							<h3 className="heroTitle">
								Enterprise-Grade Security & Unmatched Reliability
							</h3>
							<div className="heroSubTitle">
								Your data is protected with advanced encryption. secure cloud
								infrastructure and real-time monitoring, ensuring 99.9% uptime
								and maximum reliability
							</div>
						</div>

						<div
							className="featureBoxBody"
							style={{
								display: "flex",
								columnGap: "20px",
								textAlign: "left",
								padding: "10px",
							}}
						>
							<div className="featureBox flair-border">
								<LockOutlined className="featureIcon" />
								<div>Data Security</div>
								<div
									className="featureList"
									style={{ display: "flex", flexDirection: "column" }}
								>
									<ul style={{ display: "grid" }}>
										<li>
											<CheckCircleFilled className="blueIcon" /> Data encryption
											with secured network
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Security audits
											regularly
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Secure cloud
											servers for data storage
										</li>
									</ul>
								</div>
							</div>
							<div className="featureBox flair-border">
								<SafetyCertificateFilled className="featureIcon" />
								<div>Reliability</div>
								<div
									className="featureList"
									style={{ display: "flex", flexDirection: "column" }}
								>
									<ul style={{ display: "grid" }}>
										<li>
											<CheckCircleFilled className="blueIcon" /> Efficient
											Operating time and availability
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Data recovery
											plans for handling any disaster situation.
										</li>
									</ul>
								</div>
							</div>
							<div className="featureBox flair-border">
								<LineChartOutlined className="featureIcon" />
								<div>Real-Time Analytics</div>
								<div
									className="featureList"
									style={{ display: "flex", flexDirection: "column" }}
								>
									<ul style={{ display: "grid" }}>
										<li>
											<CheckCircleFilled className="blueIcon" /> Track and
											Display real-time usage statistics of key features, which
											can help us identify the bottlenecks or area for
											improvements.
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Collecting
											real-time feedback, such as ratings, comments or
											satisfactory score
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="showCaseBox">
					<div className="homeContentBody container">
						<span className="heroBadge ">Why Choose Us</span>
						<div className="heroTitleBody">
							<h3 className="heroTitle">Why Choose Ease Margin</h3>
							<div className="heroSubTitle ">
								Ease Margin is built to help businesses optimize operations,
								reduce manual tasks, and drive profitability with seamless
								automation and real-time insights
							</div>
						</div>

						<div
							className="featureBoxBody"
							style={{
								display: "flex",
								columnGap: "20px",
								textAlign: "center",
								padding: "10px",
							}}
						>
							<div className="chooseFeatureBox">
								<h5 className="link">Easy User Interface</h5>
								<p>
									User-Friendly and easy-to-navigate interface.
								</p>
								<img src={pngTree} />
							</div>
							<div className="chooseFeatureBox">
								<h5 className="link">Customization</h5>
								<p>
									Flexibility in customization processes and workflow. Data
									mapping from one document to another is used to automate the
									process.
								</p>
								<img src={peopleCreating} alt="peopleCreating" />
							</div>
							<div className="chooseFeatureBox">
								<h5 className="link">Support and Training.</h5>
								<p>
									Monday to Friday between 10:00AM to 7:00PM support service.
									Training programs and informative webinars with Industry
									experts.
								</p>
								<img src={place_holder} alt="Place-holder" />
							</div>
						</div>
						<div
							className="featureBoxBody"
							style={{
								display: "flex",
								columnGap: "20px",
								textAlign: "center",
								padding: "10px",
							}}
						>
							<div className="chooseFeatureBox">
								<h5 className="link">Cost & Time Savings</h5>
								<p>
									Automate manual work, reduce errors, and save both money and hours every month.
								</p>
								<img src={costsaving} />
							</div>
							<div className="chooseFeatureBox">
								<h5 className="link">Seamless Tally Integration</h5>
								<p>
									Invoices and payments flow automatically into Tally - saving
									hours of manual work and ensuring accurate GST.
								</p>
								<img src={tally} alt="tally" />
							</div>
							<div className="chooseFeatureBox">
								<h5 className="link">Faster Implementation</h5>
								<p>
									Get Ease Margin up and running in just 2 weeks, so your business can start saving time and improving efficiency without delays.
								</p>
								<img src={fast_implement} alt="Place-holder" />
							</div>
						</div>
					</div>
				</div>

				<div style={{ background: "#FFFFFF", padding: "10px 0" }}>
					<div className="homeContentBody container">
						<span className="heroBadge ">Pricing</span>
						<div className="heroTitleBody">
							<h3 className="heroTitle">The Right Plan for Smarter Manufacturing</h3>
							{/* <div className="heroSubTitle">Choose the perfect plan that hits your business needs. No Commitments, Cancel anytime</div> */}
							<div className="heroSubTitle flex flex-col leading-tight">
								Simplify operations, gain real-time visibility, and grow your business with a plan that fits your needs.
							</div>
						</div>

						<Radio.Group
							value={this.state.planSize}
							onChange={(e) => {
								this.setState({
									planSize: e.target.value,
								});
							}}
						>
							<Radio.Button value="quarterly">Quarterly</Radio.Button>
							<Radio.Button value="yearly">Yearly</Radio.Button>
						</Radio.Group>

						<div className="pricingBoxBody pricingBoxInline">
							<div
								className={
									this.state.activeBlock == "free"
										? "activePricingBox"
										: "pricingBox"
								}
								onClick={() => {
									this.setState({
										activeBlock: "free",
									});
								}}
							>
								<h6>Free</h6>
								<span className="priceValue">Free</span>
								<p>Unlimited Invoicing</p>
								<div className="featureList">
									<ul>
										<li>
											<CheckCircleFilled className="blueIcon" /> Single User
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> B2C and B2B
											Billing
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Create
											Quotations
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Analytics and
											Reports
										</li>
									</ul>
									<Button
										style={{ marginTop: '1.5rem', marginBottom: '1rem' }}
										type={
											this.state.activeBlock === "free" ? "default" : "primary"
										}
										className="w-full h-12 rounded-full font-medium transition-all"
										onClick={() => {
											window.location.href = "/requestdemo";
										}}
									>
										Request a demo
									</Button>
								</div>
								{/* <Button
									type={
										this.state.activeBlock == "free" ? "default" : "primary"
									}
									className="freeTrialButton"
									onClick={() => {
										window.location.href = "/sign-up";
									}}
								>
									Get Started Free
								</Button> */}
							</div>
							<div
								className={
									this.state.activeBlock == "silver"
										? "activePricingBox"
										: "pricingBox"
								}
								onClick={() => {
									this.setState({
										activeBlock: "silver",
									});
								}}
							>
								<h6>Silver</h6>
								{/* <div style={{color:'#fc787d'}} className="priceValue">
									{this.state.planSize === "quarterly"
										? "1799.00 INR/quarter"
										: "599.00 INR/month"}
								</div> */}
								<div className="flex space-x-1 items-start">
									<span className={`text-[25px] font-semibold ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : "text-[#1780fb]"}`}>Rs</span>
									<span className={`text-[55px] font-bold ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : "text-[#1780fb]"} leading-none`}>{this.state.planSize === "quarterly" ? 2397 : 599}</span>
									<span className={`text-[25px] font-semibold ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : "text-[#1780fb]"}`}>.00</span>
								</div>
								<div className="flex flex-col items-end">
									<div className="relative w-fit inline-block">
										<div className="flex items-center space-x-1">
											<span className={`text-[20px] font-semibold ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : ""}`}>{this.state.planSize === "quarterly" ? 3999 : 999}</span>
											<span className={`text-[20px] font-semibold ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : ""}`}>Rs</span>
											<span className="text-[20px] text-red-500">*</span>
										</div>

										{/* perfect center strike for 20px text */}
										<span
											className="absolute left-0 right-0
											 top-1/2 -translate-y-1/2
											  h-[3px] bg-[#ff7a7a]
											   rotate-[-10deg] rounded-full"
										></span>
									</div>
									<span className={`text-[14px] ${this.state.activeBlock === "silver" ? "text-[#ffffff]" : ""}`}>
										/ user / {this.state.planSize === "quarterly" ? "quarter" : "month"}
									</span>
								</div>



								{/* <div className="flex  items-center">
									<div className="flex items-baseline gap-2">
										<span className="text-[10px] font-semibold text-[#ff6f6f]">Rs</span>
										<span className="text-[10px]  text-[#ff6f6f] leading-none">580</span>
										<span className="text-[10px] font-semibold text-[#ff6f6f] mb-[6px]">.00</span>
									</div>
									<div className="relative mt-1">
										<span className="text-lg text-gray-500 line-through">725.00 Rs</span>
										<span className="absolute inset-y-0 left-0 w-full h-[2px] bg-[#ff6f6f] transform rotate-[10deg] origin-left"></span>
										<span className="absolute top-0 right-[-10px] text-[#ff6f6f] text-sm font-semibold">*</span>
									</div>
									<p className="text-base text-gray-600 mt-1">/ user / month</p>
								</div> */}
								<p>
									Billed{" "}
									{this.state.planSize === "yearly" ? "Yearly" : "Quarterly"}
								</p>
								<div className="featureList">
									<ul>
										{/* <li>
											<CheckCircleFilled className="blueIcon" /> Upto 5 Users
										</li> */}
										<li>
											<CheckCircleFilled className="blueIcon" /> Manage Sales
											and Purchase
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Inventory
											Management
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Sales and
											Purchase Forcasting
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Dashboard and
											Reports
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Reminder and
											Alerts
										</li>
									</ul>
									<Button
										style={{ marginTop: '1.5rem', marginBottom: '1rem' }}
										type={
											this.state.activeBlock === "silver" ? "default" : "primary"
										}
										className="w-full h-12 rounded-full font-medium transition-all"
										onClick={() => {
											window.location.href = "/requestdemo";
										}}
									>
										Request a demo
									</Button>
								</div>
							</div>
							<div
								className={
									this.state.activeBlock == "gold"
										? "activePricingBox"
										: "pricingBox"
								}
								onClick={() => {
									this.setState({
										activeBlock: "gold",
									});
								}}
							>
								<h6>Gold</h6>
								{/* <div className="priceValue">
									{this.state.planSize === "quarterly"
										? "40,000 INR/quarter"
										: "10,000 INR/month"}
								</div> */}
								<div className="flex space-x-1 items-start">
									<span className={`text-[25px] font-semibold ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : "text-[#1780fb]"}`}>Rs</span>
									<span className={`text-[55px] font-bold ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : "text-[#1780fb]"} leading-none`}>{this.state.planSize === "quarterly" ? 3000 : 799}</span>
									<span className={`text-[25px] font-semibold ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : "text-[#1780fb]"}`}>.00</span>
								</div>
								<div className="flex flex-col items-end">
									<div className="relative w-fit inline-block">
										<div className="flex items-center space-x-1">
											<span className={`text-[20px] font-semibold ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : ""}`}>{this.state.planSize === "quarterly" ? 4999 : 1399}</span>
											<span className={`text-[20px] font-semibold ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : ""}`}>Rs</span>
											<span className="text-[20px] text-red-500">*</span>
										</div>

										{/* perfect center strike for 20px text */}
										<span
											className="absolute left-0 right-0
											 top-1/2 -translate-y-1/2
											  h-[3px] bg-[#ff7a7a]
											   rotate-[-10deg] rounded-full"
										></span>
									</div>
									<span className={`text-[14px] ${this.state.activeBlock !== "silver" ? "text-[#ffffff]" : ""}`}>
										/ user / {this.state.planSize === "quarterly" ? "quarter" : "month"}
									</span>
								</div>
								<p>
									Billed{" "}
									{this.state.planSize === "yearly" ? "Yearly" : "Quarterly"}
								</p>
								<div className="featureList">
									<ul>
										{/* <li>
											<CheckCircleFilled className="blueIcon" /> Upto 10 Users
										</li> */}
										<li>
											<CheckCircleFilled className="blueIcon" /> Manage multiple
											stores
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Advanced
											Analytics
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Create Bill of
											Materials
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Manage
											Production
										</li>
										<li>
											<CheckCircleFilled className="blueIcon" /> Additional
											Silver Plan Features
										</li>
									</ul>
									<Button
										style={{ marginTop: '1.5rem', marginBottom: '1rem' }}
										type={
											this.state.activeBlock === "gold" ? "default" : "primary"
										}
										className="w-full h-12 rounded-full font-medium transition-all"
										onClick={() => {
											window.location.href = "/requestdemo";
										}}
									>
										Request a demo
									</Button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="newsLetter">
					<div className="newsletterBody container">
						<div className="newsletterBodyContent">
							<h3>Ready To Transform Your Business?</h3>
							<p>
								Discover how Ease Margin is helping companies simplify operations and grow smarter.
							</p>
							<div className="flexBox" style={{ justifyContent: "center" }}>
								<Input
									placeholder="Your Email Address"
									style={{ maxWidth: "500px" }}
									required
									type="email"
									value={this.state.email}
									onChange={(e) => this.setState({ email: e.target.value })}
								/>
								<Button type="primary" onClick={this.handleNewsletterSubscribe}>
									Subscribe
								</Button>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	newsLettersData: state.api.getNewsLetters?.data?.data,
	addNewsLettersState: state.api?.addNewsLetters,
});

const mapDispatchToProps = (dispatch: any) => ({
	addNewsLetters: (payload: any) => dispatch(addNewsLetters(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Features);
